//app.js
import React from 'react';
import FrameRouter from './router/FrameRouter';

import 'rsuite/dist/styles/rsuite-default.css';
import './App.css';
import './css/commom.css';

class App extends React.Component 
{
	render() 
	{
		return (
			<FrameRouter />
		)	
	}
}

export default App;